<div class="featured-product-icon-group">
    <div *ngFor="let product of products"
         class="featured-product-icon-group__product"
    >
        <app-featured-product-icon [config]="product"
        ></app-featured-product-icon>
    </div>
</div>
